var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Sheet',{staticClass:"container"},[_c('span',{staticClass:"opps hidden-sm-and-down"},[_vm._v("OPPS!")]),_c('span',{staticClass:"opps sm hidden-md-and-up"},[_vm._v("OPPS!")]),_c('h1',[_vm._v("404")]),_c('h3',[_vm._v("找不到此頁面!!")])])}
var staticRenderFns = []

export { render, staticRenderFns }